// removed by extract-text-webpack-plugin
module.exports = {"personBadge":"W_qbI9-3ZPoYpaZCwJl9M","select":"_3yRfUs2VllofmboHw57EAQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/act/PersonField.css
 ** module id = 930
 ** module chunks = 1
 **/